"use client"

import { NavigationMenu, NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuTrigger } from "@/components/ui/navigation-menu";
import { Box, CalendarClock, Captions, CircleHelp, FileText, LineChart, Newspaper } from 'lucide-react';
import Link from 'next/link';
import React from 'react';
import Icons from '../ui/icons';

interface Props {
    title: string;
    href: string;
    children: React.ReactNode;
    icon: React.ReactNode;
}

const Menu = () => {
    return (
        <NavigationMenu>
            <NavigationMenuList>
                <NavigationMenuItem>
                    <Link href="/shop" legacyBehavior passHref>
                        <NavigationMenuLink className="h-10 px-4 py-2 text-sm font-normal rounded-md text-muted-foreground hover:text-foreground w-max hover:bg-none">
                            فروشگاه بازی
                        </NavigationMenuLink>
                    </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                    <Link href="/shop/pubg" legacyBehavior passHref>
                        <NavigationMenuLink className="h-10 px-4 py-2 text-sm font-normal rounded-md text-muted-foreground hover:text-foreground w-max hover:bg-none">
                            خرید یوسی پابجی
                        </NavigationMenuLink>
                    </Link>

                    <NavigationMenuContent>
                        <ul className="grid rounded-3xl gap-3 p-4 md:w-[400px] lg:w-[500px] xl:w-[550px] lg:grid-cols-[.75fr_1fr]">
                            <li className="row-span-3">
                                <NavigationMenuLink asChild>
                                    <Link
                                        href="/"
                                        className="flex flex-col justify-end w-full h-full p-4 no-underline rounded-lg outline-none select-none bg-gradient-to-tr from-secondary to-secondary/50 focus:shadow-md"
                                    >
                                        <Icons.icon className="w-6 h-6" />
                                        <div className="my-2 text-lg font-normal">
                                            جدیدترین بازی‌ها
                                        </div>
                                        <p className="text-sm text-muted-foreground">
                                            بهترین بازی‌های سال ۲۰۲۴
                                        </p>
                                    </Link>
                                </NavigationMenuLink>
                            </li>
                            <Item title="بازی‌های آنلاین" href="/games/online" icon={<Captions className="w-5 h-5" />}>
                                بازی‌های چندنفره آنلاین
                            </Item>
                            <Item title="بازی‌های داستانی" href="/games/story-mode" icon={<CalendarClock className="w-5 h-5" />}>
                                بهترین بازی‌های داستان محور
                            </Item>
                            <Item title="بازی‌های مسابقه‌ای" href="/games/racing" icon={<LineChart className="w-5 h-5" />}>
                                تجربه سرعت و هیجان در دنیای مجازی
                            </Item>
                        </ul>
                    </NavigationMenuContent>
                </NavigationMenuItem>
                <NavigationMenuItem>
                    <Link href="/blog" legacyBehavior passHref>
                        <NavigationMenuLink className="h-10 px-4 py-2 text-sm font-normal rounded-md text-muted-foreground hover:text-foreground w-max hover:bg-none">
                            بلاگ گیمینگ
                        </NavigationMenuLink>
                    </Link>
                </NavigationMenuItem>
                {/* <NavigationMenuItem>
                    <Link href="/tournaments" legacyBehavior passHref>
                        <NavigationMenuLink className="h-10 px-4 py-2 text-sm font-normal rounded-md text-muted-foreground hover:text-foreground w-max hover:bg-none">
                            تورنمنت‌ها
                        </NavigationMenuLink>
                    </Link>
                </NavigationMenuItem> */}
                {/* <NavigationMenuItem>
                    <NavigationMenuTrigger className="text-muted-foreground hover:text-foreground">
                        منابع
                    </NavigationMenuTrigger>
                    <NavigationMenuContent>
                        <ul className="grid w-[400px] gap-3 p-4 md:w-[400px] md:grid-cols-2 lg:w-[500px] xl:w-[500px]">
                            <Item title="راهنماها" href="/resources/guides" icon={<Newspaper className="w-5 h-5" />}>
                                راهنمایی و ترفندهای بازی
                            </Item>
                            <Item title="بررسی‌ها" href="/resources/reviews" icon={<FileText className="w-5 h-5" />}>
                                بررسی تخصصی بازی‌ها
                            </Item>
                            <Item title="ابزارهای گیمینگ" href="/resources/tools" icon={<Box className="w-5 h-5" />}>
                                ابزارهای مفید برای گیمرها
                            </Item>
                            <Item title="پشتیبانی" href="/resources/support" icon={<CircleHelp className="w-5 h-5" />}>
                                ارتباط با تیم پشتیبانی
                            </Item>
                        </ul>
                    </NavigationMenuContent>
                </NavigationMenuItem> */}
            </NavigationMenuList>
        </NavigationMenu>

    )
};

const Item = ({ title, href, children, icon, ...props }: Props) => {
    return (
        <li>
            <NavigationMenuLink asChild>
                <Link
                    passHref
                    href={href}
                    {...props}
                    className="grid grid-cols-[.15fr_1fr] select-none space-y-1 rounded-lg p-3 leading-none no-underline outline-none transition-colors hover:bg-accent/50 hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground group"
                >
                    <div className="flex items-center mt-1 justify-center p-1 w-8 h-8 rounded-md border border-border/80">
                        {icon}
                    </div>
                    <div className="text-start mr-3">
                        <span className="text-sm group-hover:text-foreground font-normal leading-none">
                            {title}
                        </span>
                        <p className="text-sm mt-0.5 line-clamp-2 text-muted-foreground">
                            {children}
                        </p>
                    </div>
                </Link>
            </NavigationMenuLink>
        </li>
    )
};

Item.displayName = "Item";

export default Menu
